module.exports = __webpack_public_path__ + "static/media/css.bb591445.svg";